export enum AuthProviderName {
  Google = 'GOOGLE',

  /**
   * @deprecated Should not be used anymore.
   * @see https://github.com/jebelapp/jebel/issues/1894
   */
  Facebook = 'FACEBOOK',

  /**
   * @deprecated Should not be used anymore.
   * @see https://github.com/jebelapp/jebel/issues/1894
   */
  LinkedIn = 'LINKEDIN',
}
